export const COOKIES_EXPIRE_TIME = 315576000000;
export const COOKIES_AGREEMENT_NAME = 'cookiesAgreement';
